import { captureAcquisitionFromBrowser } from './core/helpers/acquisition-tracking';
import { captureBillingPromotion } from './modules/billing/services/billing-promotion';
import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ToastModule } from 'primeng/toast';

import { FullscreenLoaderComponent } from './shared/components/fullscreen-loader/fullscreen-loader.component';
import { PlanLimitModalComponent } from './shared/components/plan-limit-modal/plan-limit-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, FullscreenLoaderComponent, PlanLimitModalComponent],
  template: `
    <p-toast
      position="top-right"
      [baseZIndex]="10000"
      [life]="4000"
      [showTransformOptions]="'translateY(-100%)'"
      [hideTransformOptions]="'translateY(-100%)'" />
    <router-outlet></router-outlet>
    <app-fullscreen-loader />
    <app-plan-limit-modal />
  `
})
export class AppComponent {
  constructor(router: Router) {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed())
      .subscribe(() => captureAcquisitionFromBrowser());
    captureBillingPromotion();
    captureAcquisitionFromBrowser();
  }
}
